export function refreshIframe(iframeIdSelector) {
  const frame = document.getElementById(iframeIdSelector);
  if (frame) {
    frame.src += '';
  }
}